var PeTool = (function () {


  Utility.log('PeTool loaded');

  var peUI;
  var $peWrapper;
  var selects = [];
  var currentSelectOptions = {};
  var selectsLoaded = 0;
  var offerDetailsLinksSelector = '.offer-card-link, [text="Offer Details"] a';
  var offerDetailsUrl = null;
  var $notificationPanel;
  var debounce;

  var initPe = function () {
    $peWrapper = $('pe-wrapper');
    var sitecoreExpEditor = !!(window.Sitecore
                    && window.Sitecore.WebEditSettings
                    && window.Sitecore.WebEditSettings.editing);
    if ($peWrapper.length >= 1 && !sitecoreExpEditor) {
      peUI = window.platform.pe.default.init()[0];
      $notificationPanel = $('.notification-panel', $peWrapper);

      // give each <select> an ID (required for SelectBox.createSelect())
      giveSelectsIDs();

      // wait for <select> to be populated before creating the custom select box
      waitForSelectLoad();

      setListeners();

      // Adding Offers zipcode palceholder
      var placeholder = window.pe && window.pe.labels && window.pe.labels.changeZip
                        && window.pe.labels.changeZip.updateButton
        ? window.pe.labels.changeZip.updateButton : 'ZIP Code';
      $('pe-wrapper input.change-zip-input').attr('placeholder', placeholder);

      // console.log('PeTool initialized.');
      // console.log('peUI object below.');
      // console.log(peUI);
    }
  };

  // setInterval to check each <select> to see if its content is populated (it comes from an API)
  // if the select has loaded then run the custom select box code on it
  var waitForSelectLoad = function () {
    var checkSelectOptionsInterval = setInterval(function () { checkForSelectLoad(); }, 500);

    function checkForSelectLoad() {
      for (var i = 0; i < selects.length; i++) {
        // only check the selects that haven't loaded yet
        if (selects[i] !== false) {
          var thisSelector = '#' + selects[i];

          // if the select has options populated then create the custom select
          // then set the select to false so we don't keep checking it
          // then increment selectsLoaded variable so we can know when all selects have loaded and stop the interval
          if ($('option', thisSelector).length > 0) {
            selects[i] = false;
            selectsLoaded++;

            // make sure there isn't an existing SelectBox before creating a new one
            if ($('[data-id="' + thisSelector.substr(1) + '"]').length === 0) {
              SelectBox.createSelect(thisSelector);
            }
          }
        }

        // if all selects have loaded stop the interval
        if (selectsLoaded === selects.length) {
          stopInterval();
          currentSelectOptions = getSelectOptions();
        }
      }
    }

    function stopInterval() {
      clearInterval(checkSelectOptionsInterval);
    }
  };

  // SelectBox.js requires IDs on select elements
  // if the select doesn't have an ID give it one
  var giveSelectsIDs = function () {
    $('select').each(function (i) {
      if (!$(this).attr('id')) {
        // use the index to make the ID unique
        var newID = 'pe-select-' + i;
        $(this).attr('id', newID);
      }

      selects[i] = $(this).attr('id');
    });
  };

  // creates an object for each <select> identified by its ID attribute
  //  and assigns the array of options to the object's option property
  var getSelectOptions = function () {
    var selectOptions = {};

    $('select:not(#model)').each(function (i, el) {
      var options = [];

      $(el).find('option').each(function (j, ele) {
        options[j] = $(ele).attr('value');
      });

      selectOptions[$(this).attr('id')] = {};
      selectOptions[$(this).attr('id')].options = options;
    });

    return selectOptions;
  };

  var handleOfferDetailsClick = function (e) {
    e.stopPropagation();
    e.preventDefault();

    // Get root-relative content-URL (delete protocol & hostname).
    // Handle offer-card offer-details cta click
    var $link = $(e.currentTarget);
    var $modal = $('#acr-modal');

    // console.log('Offer Details link clicked! e object:');
    // console.log(e);
    // console.log('offerDetailsUrl: ' + offerDetailsUrl);

    // Slight delay to allow OPEN_OFFER_DETAILS bus-event-handler to populate offerDetailsUrl.
    setTimeout(function () {
      $link.attr({
        href: offerDetailsUrl,
        'data-raq': 'false',
        'data-modal-type': 'large',
      });

      $modal
        .addClass('modal-offer-details')
        .find('.acr-modal-close').one('click', function () {
          $modal.removeClass('modal-offer-details modal-large');
        });

      Modals.addCallback(function checkModalImage() {
        var $modalHeader = $('.modal-offer-details .offer-detail-modal-header');
        if ($modalHeader.length === 1) {
          if ($modalHeader.hasClass('no-image')) {
            $modal.addClass('no-image');
          } else {
            $modal.removeClass('no-image');
          }
        }
      });

      $(document).trigger('activateModal', e);

      // remove the attribute so we don't trigger the modal twice on the next click
      $link.removeAttr('data-modal-type');

      offerDetailsUrl = null;

    }, 100);
  };

  var openNotificationPanel = function (contentStr) {
    var $contentSpan = $notificationPanel.find('span');
    var defaultContent = $contentSpan.text();
    var $titleH3 = $notificationPanel.find('h3.vehicle-disclaimer-title');
    var $containerDiv = $notificationPanel.find('div');
    var titleContent = window.pe
      && window.pe.labels
      && window.pe.labels.selectModel
      && window.pe.labels.selectModel.total
      ? '*' + window.pe.labels.selectModel.total
      : '';

    $notificationPanel.find('h3').hide();

    if ($titleH3.length) {
      $titleH3.text(titleContent);
      $titleH3.show();
    } else {
      var h3 = $('<h3/>');
      h3.addClass('vehicle-disclaimer-title');
      h3.text(titleContent);
      $containerDiv.prepend(h3);
    }

    $contentSpan.text(contentStr);
    $notificationPanel.addClass('is-open');
    $notificationPanel.find('button').one('click', function () {
      $contentSpan.text(defaultContent);
      $notificationPanel.removeClass('is-open');
    });
  };

  var removeVehicleNotificationInfo = function () {
    $notificationPanel.find('h3').show();
    $notificationPanel.find('h3.vehicle-disclaimer-title').remove();
  };

  // sets height of all offer cards equal to height of the tallest card
  // this prevents a jumpy behavior when the user scrolls through the carousel
  // to a card that is taller than the previous
  var setOfferCardHeight = function () {
    var $offerCards = $('.ui-slide');

    $offerCards.css('height', 'auto');

    var tallestCard = 0;

    $offerCards.each(function () {
      tallestCard = ($(this).height() > tallestCard) ? $(this).height() : tallestCard;
    });

    $offerCards.css('height', tallestCard);
  };

  function onResize() {
    clearTimeout(debounce);
    debounce = setTimeout(setOfferCardHeight, 250);
  }

  function onPaymentUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(updateDropdowns(), 500);
  }

  var setAppliedOfferCardSize = function ($applyOfferBtn) {
    var $origCard = $applyOfferBtn.closest('.offer-card-container');
    var $appliedCard = $origCard.closest('.pe-offer-card').next('.pe-selected-offer');
    var origCardWidth = $origCard.outerWidth();
    var origCardHeight = $origCard.outerHeight();

    $appliedCard
      .outerWidth(origCardWidth)
      .outerHeight(origCardHeight);
  };

  // check if the list of options for the <select> matches previous list of options for the select
  // only if things have changed will we recreate our selectboxes
  var updateDropdowns = function () {
    var newSelectOptions = getSelectOptions();

    $('select:not(#model)').each(function () {
      var id = $(this).attr('id');

      // <select> options don't match - create a new selectBox and update currentOptions

      var $customSelect = $(this).next('.acr-select-box-cloned');

      $customSelect.remove();

      SelectBox.createSelect('#' + id);

      currentSelectOptions = newSelectOptions;


    });
  };

  function checkArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) { return false; }
    for (var i = arr1.length; i--;) {
      if (arr1[i] !== arr2[i]) { return false; }
    }

    return true;
  }

  var setListeners = function () {
    $(window).resize(onResize);

    peUI.bus.on(peUI.bus.EVENTS.VEHICLE.OPEN_DISCLAIMER, function (e) {
      openNotificationPanel(e.disclaimer);
    });

    peUI.bus.on(peUI.bus.EVENTS.DISCLAIMER.OPEN, function () {
      removeVehicleNotificationInfo();
    });

    $(document).on('mousedown', '.offer-card-button', function (e) {
      setAppliedOfferCardSize($(e.originalEvent.target));
    });

    // trigger RAQ
    $(document).on('click', '.pe-whats-next-ctas .raq-cta, .offer-detail-modal-box .raq-cta', function (e) {
      $(e.currentTarget).attr('data-raq', 'true').attr('data-modal-type', 'large');

      $(document).trigger('activateModal', e);

      // remove the attribute so we don't trigger the modal twice on the next click
      $(e.currentTarget).removeAttr('data-modal-type');

      e.preventDefault();
    });

    peUI.bus.on(peUI.bus.EVENTS.OFFER.OPEN_OFFER_DETAILS, function (data) {
      offerDetailsUrl = data.url;
    });

    peUI.bus.on(peUI.bus.EVENTS.OFFERS_CONTAINER.UPDATE_OFFERS + ' '
      + peUI.bus.EVENTS.OFFERS_CONTAINER.UPDATE_SPECIAL_OFFERS, function (data) {
      $(offerDetailsLinksSelector)
        .off('click', handleOfferDetailsClick)
        .on('click', handleOfferDetailsClick);

      // set height of offer cards
      setOfferCardHeight();
    });

    peUI.bus.on(peUI.bus.EVENTS.FORM.UPDATE_DROPDOWNS, function () {
      var numOfDropdowns = $('select').length;

      if (selectsLoaded === numOfDropdowns) {
        onPaymentUpdate();
      }
    });
  };

  return {
    initPe: initPe,
  };
}());
